<template>
  <svg
    class="icon-glyph"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <circle v-if="name === 'user'" cx="12" cy="8" r="3.25" />
    <path
      v-if="name === 'user'"
      d="M5.5 20c.6-3.55 2.75-5.35 6.5-5.35s5.9 1.8 6.5 5.35"
    />

    <path
      v-if="name === 'log-out'"
      d="M14 5h4.25A1.75 1.75 0 0 1 20 6.75v10.5A1.75 1.75 0 0 1 18.25 19H14"
    />
    <path
      v-if="name === 'log-out'"
      d="M10.5 8.25 14.25 12l-3.75 3.75M14 12H4"
    />

    <path
      v-if="name === 'package'"
      d="m4.5 7.5 7.5 4 7.5-4M12 11.5V20M18.7 5.95 12 2.5 5.3 5.95v12.1L12 21.5l6.7-3.45z"
    />
    <path v-if="name === 'package'" d="m8.3 3.65 7.4 4M5 6l7 3.8L19 6" />

    <path v-if="name === 'arrow-right'" d="M4 12h15M13 6l6 6-6 6" />
    <path v-if="name === 'arrow-left'" d="M20 12H5M11 6l-6 6 6 6" />
    <path v-if="name === 'chevron-down'" d="m6 9 6 6 6-6" />
    <path v-if="name === 'check'" d="m5 12.5 4.3 4.3L19 7" />

    <path
      v-if="name === 'shield'"
      d="M12 3.25 19 6v5.2c0 4.35-2.65 7.95-7 9.55-4.35-1.6-7-5.2-7-9.55V6z"
    />
    <path v-if="name === 'shield'" d="m9 12 2 2 4-4" />

    <path
      v-if="name === 'phone'"
      d="M7.1 4.25 9.3 3.5l2 4.7-1.55 1.15c.75 1.6 1.8 2.65 3.4 3.4l1.15-1.55 4.7 2-.75 2.2c-.25.75-.95 1.25-1.75 1.2-6.55-.4-11.45-5.3-11.85-11.85-.05-.8.45-1.5 1.2-1.75Z"
    />

    <circle v-if="name === 'clock'" cx="12" cy="12" r="8" />
    <path v-if="name === 'clock'" d="M12 7.5v4.9l3.2 1.8" />

    <circle v-if="name === 'search'" cx="10.75" cy="10.75" r="5.75" />
    <path v-if="name === 'search'" d="m15 15 4.5 4.5" />

    <circle v-if="name === 'info'" cx="12" cy="12" r="8.5" />
    <path v-if="name === 'info'" d="M12 10.5v5M12 7.5h.01" />

    <path
      v-if="name === 'calendar'"
      d="M5 5.5h14v14H5zM8 3.5v4M16 3.5v4M5 9h14"
    />
    <path v-if="name === 'truck'" d="M3.5 6h10v10h-10zM13.5 10h3l3 3v3h-6z" />
    <circle v-if="name === 'truck'" cx="7" cy="18" r="1.5" />
    <circle v-if="name === 'truck'" cx="17" cy="18" r="1.5" />
    <path
      v-if="name === 'printer'"
      d="M6 9V4h12v5M6 17H4.5A1.5 1.5 0 0 1 3 15.5v-4A1.5 1.5 0 0 1 4.5 10h15a1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 0 1-1.5 1.5H18M6 14h12v7H6z"
    />
    <path
      v-if="name === 'list'"
      d="M8 6h11M8 12h11M8 18h11M4.5 6h.01M4.5 12h.01M4.5 18h.01"
    />
    <path
      v-if="name === 'lock'"
      d="M6 10h12v10H6zM8.5 10V7.75a3.5 3.5 0 0 1 7 0V10"
    />
  </svg>
</template>

<script>
export default {
  name: "IconGlyph",
  props: {
    name: { type: String, required: true },
    size: { type: [String, Number], default: 24 }
  }
};
</script>

<style>
.icon-glyph {
  display: block;
  flex: 0 0 auto;
}
</style>
